import "core-js/modules/es.regexp.exec.js";
import { useCssVars as _useCssVars, unref as _unref } from 'vue';
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6fbc94ed"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "recommend-tabs-h5"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "全部", -1));
const _hoisted_3 = [_hoisted_2];
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "老哥", -1));
const _hoisted_5 = [_hoisted_4];
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "老姐", -1));
const _hoisted_7 = [_hoisted_6];
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "官方", -1));
const _hoisted_9 = [_hoisted_8];
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "爆奖", -1));
const _hoisted_11 = [_hoisted_10];
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "杂谈", -1));
const _hoisted_13 = [_hoisted_12];
import { onMounted, ref } from 'vue';
export default {
  __name: 'recommendTabsH5',
  props: {
    modelValue: {
      type: String
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    _useCssVars(_ctx => ({
      "4b9ecc14": top.value,
      "16b4b0cd": translate.value
    }));
    const top = ref('50%');
    const translate = ref('translate(-50%, -50%)');
    onMounted(() => {
      const ios = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      top.value = ios ? '55%' : '50%';
      translate.value = ios ? 'translate(-50%, -55%)' : 'translate(-50%, -50%)';
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: _normalizeClass([{
          active: __props.modelValue === 'all'
        }]),
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('update:modelValue', 'all'))
      }, _hoisted_3, 2), _createElementVNode("div", {
        class: _normalizeClass([{
          active: __props.modelValue === 'laoge'
        }]),
        onClick: _cache[1] || (_cache[1] = $event => _ctx.$emit('update:modelValue', 'laoge'))
      }, _hoisted_5, 2), _createElementVNode("div", {
        class: _normalizeClass([{
          active: __props.modelValue === 'laojie'
        }]),
        onClick: _cache[2] || (_cache[2] = $event => _ctx.$emit('update:modelValue', 'laojie'))
      }, _hoisted_7, 2), _createElementVNode("div", {
        class: _normalizeClass([{
          active: __props.modelValue === 'official'
        }]),
        onClick: _cache[3] || (_cache[3] = $event => _ctx.$emit('update:modelValue', 'official'))
      }, _hoisted_9, 2), _createElementVNode("div", {
        class: _normalizeClass([{
          active: __props.modelValue === 'baojian'
        }]),
        onClick: _cache[4] || (_cache[4] = $event => _ctx.$emit('update:modelValue', 'baojian'))
      }, _hoisted_11, 2), _createElementVNode("div", {
        class: _normalizeClass([{
          active: __props.modelValue === 'zatan',
          'hidden': true
        }]),
        onClick: _cache[5] || (_cache[5] = $event => _ctx.$emit('update:modelValue', 'zatan'))
      }, _hoisted_13, 2)]);
    };
  }
};